const USER_DEFAULT_SORT = {
    label: 'Name',
    value: 'Name',
    sort: [{ firstName: { order: 'asc' } }],
};

const USER_DEFAULT_FILTER = { terms: { status: ['Active', 'Created'] } };

export { USER_DEFAULT_SORT, USER_DEFAULT_FILTER };
